import * as React from 'react'
import { Box, IconButton, Menu, MenuItem, Tab, useMediaQuery, useTheme } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import MenuIcon from '@mui/icons-material/Menu'
import { AccueilTab } from './Accueil'
import { Galerie } from './Galerie'
import { Contact } from './Contact'
import { Reservation } from './Reservation'
import Shows from './Shows'
import { ReservationContextProvider } from '../context/ReservationContext'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

export const reservationRetryRef = { current: null }

export function MainTabs({ idx = '1', step = 0 }) {
  const [selectedTab, setSelectedTab] = React.useState(idx)
  const [scrollToShow, setScrollToShow] = React.useState(null)
  const [mobileMenuAnchor, setMobileMenuAnchor] = React.useState(null)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const navigate = useNavigate()

  React.useEffect(() => {
    setSelectedTab(idx)
  }, [idx])

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue)
    setMobileMenuAnchor(null) // Close mobile menu when tab is selected
  }

  const handleMobileMenuOpen = (event) => {
    setMobileMenuAnchor(event.currentTarget)
  }

  const handleMobileMenuClose = () => {
    setMobileMenuAnchor(null)
  }

  const handleMobileMenuSelect = (value) => {
    // If we're switching to the home tab (value '1') and we're already on /spectacles
    // but with a hash, we need to navigate to the clean URL first
    if (value === '1' && window.location.pathname === '/spectacles') {
      // Navigate to the clean URL without hash to force a proper re-render
      navigate('/spectacles', { replace: true })
    }

    setSelectedTab(value)
    setMobileMenuAnchor(null)
  }

  return (
    <Box sx={{ flex: 1 }}>
      <TabContext value={selectedTab}>
        <Box display='flex' sx={{ borderBottom: 1, borderColor: 'divider', justifyContent: 'flex-start', alignItems: 'center' }}>
          {isMobile ? (
            // Mobile hamburger menu
            <Box sx={{ ml: 3, width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
              <IconButton edge='start' color='inherit' aria-label='menu' onClick={handleMobileMenuOpen}>
                <MenuIcon />
              </IconButton>
            </Box>
          ) : (
            // Desktop tab list
            <TabList onChange={handleChangeTab} centered>
              <Tab label='Accueil' value='1' />
              <Tab label='Spectacles' value='2' />
              <Tab label='Réservation' value='3' />
              <Tab label='Galerie' value='4' />
              <Tab label='Contact' value='5' />
            </TabList>
          )}
        </Box>

        {/* Mobile menu */}
        <Menu anchorEl={mobileMenuAnchor} open={Boolean(mobileMenuAnchor)} onClose={handleMobileMenuClose}>
          <MenuItem onClick={() => handleMobileMenuSelect('1')}>👉 Accueil</MenuItem>
          <MenuItem onClick={() => handleMobileMenuSelect('2')}>🎭 Spectacles</MenuItem>
          <MenuItem onClick={() => handleMobileMenuSelect('3')}>✨ Réservation</MenuItem>
          <MenuItem onClick={() => handleMobileMenuSelect('4')}>📷 Galerie</MenuItem>
          <MenuItem onClick={() => handleMobileMenuSelect('5')}>📬 Contact</MenuItem>
        </Menu>
        <TabPanel value='1'>
          <AccueilTab setSelectedTab={setSelectedTab} setScrollToShow={setScrollToShow} />
        </TabPanel>
        <TabPanel value='2'>
          <Shows setSelectedTab={setSelectedTab} scrollToShow={scrollToShow} />
        </TabPanel>
        <TabPanel value='3'>
          <ReservationContextProvider reservationRetryRef={reservationRetryRef}>
            <Reservation step={step} setSelectedTab={setSelectedTab} />
          </ReservationContextProvider>
        </TabPanel>
        <TabPanel value='4'>
          <Galerie />
        </TabPanel>
        <TabPanel value='5'>
          <Contact />
        </TabPanel>
      </TabContext>
    </Box>
  )
}

MainTabs.propTypes = {
  idx: PropTypes.string,
  step: PropTypes.number
}
